export class ExpUtils {
  // Total XP required to reach a certain level
  static expForLevel(level: number): number {
    const x = Math.max(1, level);
    const x3 = x * x * x;

    if (x <= 15) {
      return Math.floor((x3 * (24 + Math.floor((x + 1) / 3))) / 50);
    }

    if (x <= 35) {
      return Math.floor((x3 * (14 + x)) / 50);
    }

    return Math.floor((x3 * (32 + Math.floor(x / 2))) / 50);
  }

  // Current level based on total XP
  static levelFromExp(exp: number, maxLevel = 100): number {
    if (exp <= 0) return 1;

    let low = 1;
    let high = maxLevel;

    // binary search to make it fast
    while (low < high) {
      const mid = Math.floor((low + high + 1) / 2);
      const midExp = ExpUtils.expForLevel(mid);

      if (midExp <= exp) {
        low = mid;
      } else {
        high = mid - 1;
      }
    }

    return low;
  }

  // How much is left to reach the next level
  static expToNext(exp: number, maxLevel = 100) {
    const level = ExpUtils.levelFromExp(exp, maxLevel);

    if (level >= maxLevel) {
      return { level, nextLevel: level, remaining: 0 };
    }

    const next = level + 1;
    const needed = ExpUtils.expForLevel(next);

    return {
      level,
      nextLevel: next,
      remaining: Math.max(0, needed - exp),
    };
  }

  /**
   * Calculates the experience reward based on the original Pokémon formula (Gen 1)
   * EXP = (Base EXP * Level) / 7
   *
   * @param baseExperience - Base experience of the defeated Pokémon
   * @param enemyLevel - Level of the defeated Pokémon
   * @returns Rewarded experience
   */
  static calculateExpReward(
    baseExperience: number,
    enemyLevel: number,
  ): number {
    return Math.floor(Math.floor((baseExperience * enemyLevel) / 7) * 0.5); // 0.5 multiplier to reduce pace
  }
}
